import React from 'react';
import { FormField, Label } from '@zillow/constellation-10';

import PropertyType_v1 from './PropertyType_v1';
import type { Section } from '../../../models/index';
import { PROPERTY_TYPE } from '../../../constants/index';
import YesAndNo from '../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  setSection: (section: Section) => void;
};

function PropertyType_v5({ section, setSectionValues, setSection }: Props): JSX.Element {
  function onNoFourUnitsOrLess(): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.FOUR_UNITS_OR_LESS]: false,
    });
  }

  function onYesFourUnitsOrLess(): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.FOUR_UNITS_OR_LESS]: true,
    });
  }

  const isMultiFamily = section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY);

  return (
    <PropertyType_v1 {...{ section, setSectionValues, setSection }}>
      {isMultiFamily && (
        <>
          <FormField
            required
            label={<Label>Does the property have 4 units or less?</Label>}
            control={
              <YesAndNo
                yesActive={section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.FOUR_UNITS_OR_LESS)}
                yesHandler={onYesFourUnitsOrLess}
                noHandler={onNoFourUnitsOrLess}
              />
            }
          />
        </>
      )}
    </PropertyType_v1>
  );
}

export default PropertyType_v5;

PropertyType_v5.description = 'Asks if the MF is more than 4 units.';
